// extracted by mini-css-extract-plugin
export var actions = "_tq-4";
export var item = "_tq-1";
export var price = "_tq-3";
export var quantity = "_tq-2";
export var table = "_tq-0";